import { Language } from '@ais-ui/locale-management';
import en from './en.json';

export const translations = {
  [Language.English]: en,
};
